<div class="header">
  <div class="header-title">Завантажити супровідні документи</div>
  <button mat-icon-button matDialogClose>
    <mat-icon>close</mat-icon>
  </button>
</div>
<div class="content">
  <div class="notice">
    <mat-icon class="notice-icon material-icons mat-select-error__icon">error_outline</mat-icon>
    <div class="notice-text">
      Виберіть зі списку потрібний тип документу для завантаження.
      <br>
      Зверніть увагу, наявність «Рахунка Проформи» або «Рахунка Фактури» є обов'язковою.
    </div>
  </div>
  <div class="types">
    <div class="types-label">Тип документу</div>
    <mat-radio-group
            class="types-list"
            [(ngModel)]="documentType">
      <mat-radio-button *ngFor="let type of documentTypes"
                        [value]="type"
                        class="types-item">
        {{ type.Label }}
      </mat-radio-button>
    </mat-radio-group>
  </div>
</div>
<div class="footer">
  <button mat-raised-button
          color="accent"
          [disabled]="!documentType"
          (click)="selectDocuments()">
    {{ selectBtnLabel }}
  </button>
</div>
